import React from 'react';
import { Check, Truck } from 'lucide-react';
import OrderCard from '@ajat/design-system/OrderCard';
import { ComponentPage, DemoCard } from '../../shared';
import { PATCH_SIGN, PATCH_BADDIE } from '../configurator/patchDemoData';

const IMAGE = require('../../../../../assets/cls-dk/products/product-1-1.jpg');

export const meta = {
  component: OrderCard,
  componentName: 'OrderCard',
  title: 'Order Card',
  group: 'Data display',
  importPath: '@ajat/design-system/OrderCard',
  description:
    'One order as a card: number, date and a status Badge in the head, one row per line (artwork, title, type chip, colour swatch + detail, DS Price) and the total. A `featured` line (the main product) shows its artwork full width above its text, with an optional zoom button. Presentation only — the page maps its order into `lines` with preformatted prices. Figma OVER-LL «Summary/My Orders» 3047:44098.',
  props: [
    ['title', 'node', '—', 'Order number / name (H4)'],
    ['meta', 'node', '—', 'Date · summary under the title'],
    ['status', '{ label, icon, onClick, ariaLabel, variant }', '—', 'With onClick a Button Tertiary/Gray (opens the order details), else a Badge'],
    ['lines', 'array', '[]', '[{ id, image, imageBackground, featured, onZoom, zoomLabel, title, chip, swatch, meta, price, originalPrice }]'],
    ['linesLabel', 'string', '—', 'Accessible name of the lines list'],
    ['totalLabel', 'node', '—', 'Total row label'],
    ['total', 'string', '—', 'Preformatted total'],
    ['className', 'string', "''", 'Additional CSS class'],
  ],
  usage: [
    {
      title: 'From an order payload',
      code: `import OrderCard from '@ajat/design-system/OrderCard';

<OrderCard
  title={\`Order #\${order.number}\`}
  meta={<time dateTime={order.placedAt}>{formatDate(order.placedAt)}</time>}
  status={{ label: 'Levererad', variant: 'success', icon: <Check size={14} /> }}
  lines={order.lines.map((l) => ({ id: l.id, image: l.image, title: l.name, meta: l.size, price: formatKr(l.price) }))}
  totalLabel="Totalt"
  total={formatKr(order.total)}
/>`,
    },
  ],
};

export default function OrderCardPage() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="Featured main product + zoom (OVER/LL «Mina ordrar»)">
        <div style={{ maxWidth: 486 }}>
          <OrderCard
            title="Order OVR-10482"
            meta={<><time dateTime="2026-09-28">28 sep. 2026</time> · 1 overall · 2 patchar</>}
            status={{ label: 'På väg', icon: <Truck size={20} strokeWidth={1.75} />, onClick: () => {}, ariaLabel: 'På väg – visa leverans och betalning' }}
            lines={[
              { id: 'o', image: IMAGE, imageBackground: 'var(--color-gray-075)', featured: true, onZoom: () => {}, zoomLabel: 'Zooma Overall', title: 'Overall', meta: 'Svart · Storlek M', price: '299 kr' },
              { id: 'p1', image: PATCH_BADDIE, title: 'Baddie', chip: 'Textpatch', meta: 'Baddie · 6 bokstäver', price: '294 kr' },
              { id: 'p2', image: PATCH_SIGN, title: 'Snapchat', chip: 'QR-patch', meta: 'Snapchat @kalle', price: '49 kr' },
            ]}
            linesLabel="Artiklar i order OVR-10482"
            totalLabel="Summa"
            total="642 kr"
          />
        </div>
      </DemoCard>
      <DemoCard title="Delivered order">
        <div style={{ maxWidth: 560 }}>
          <OrderCard
            title="Order #100041"
            meta={<><time dateTime="2026-09-01">1 sep. 2026</time> · 1 overall, 2 patchar</>}
            status={{ label: 'Levererad', variant: 'success', icon: <Check size={14} strokeWidth={2} /> }}
            lines={[
              { id: 'o', image: IMAGE, imageBackground: 'var(--color-gray-075)', title: 'Hoodie', swatch: '#1B365D', meta: 'Navy · M', price: '449,-' },
              { id: 'p1', image: PATCH_SIGN, title: 'Snapchat', chip: 'QR-patch', meta: '@kalle', price: '49 kr' },
              { id: 'p2', image: PATCH_BADDIE, title: 'Baddie', chip: 'Vanlig patch', price: '29 kr', originalPrice: '49 kr' },
            ]}
            linesLabel="Rader i order 100041"
            totalLabel="Totalt"
            total="527 kr"
          />
        </div>
      </DemoCard>
      <DemoCard title="On its way">
        <div style={{ maxWidth: 560 }}>
          <OrderCard
            title="Order #100042"
            meta={<time dateTime="2026-10-03">3 okt. 2026</time>}
            status={{ label: 'På väg', icon: <Truck size={14} strokeWidth={2} /> }}
            lines={[{ id: 'o', image: IMAGE, title: 'T-shirt', meta: 'Vit · L', price: '199,-' }]}
            totalLabel="Totalt"
            total="199,-"
          />
        </div>
      </DemoCard>
    </ComponentPage>
  );
}
